module.exports = __webpack_public_path__ + "distribution/img/log_banner_null.a5c8bae5.png";